import React, { Component } from "react";
import indigo from "./images/indigo.png";
import airindia from "./images/airindia.png";
import vistara from "./images/vistara.png";

class FlightList extends Component {
  render() {
    return (
      <div className="flight-wrapper">
        <div className="route-header">
          <div className="route-col">
            <span className="route-label">From</span>
            <span className="route-airport">
              Rajiv Gandhi International Airport (HYD) Hyderabad
            </span>
          </div>

          <div className="route-col">
            <span className="route-label">To</span>
            <span className="route-airport">
              Goa International Airport (GOI) GOA 
            </span>
          </div>

          <div className="route-col">
            <span className="route-label">Travel Date</span>
            <span className="route-airport">10 Feb 2026</span>
          </div>
        </div>

       
        <div className="flight-section">
       
          <div className="flight-column">
            <h3 className="flight-title">Departure Flights</h3>

            <FlightCard
              logo={indigo}
              airline="IndiGo"
              flight="6E-234"
              time="06:00 - 07:30"
              duration="1h 30m"
              price="₹4,500"
            />

            <FlightCard
              logo={airindia}
              airline="Air India"
              flight="AI-102"
              time="09:00 - 10:45"
              duration="1h 45m"
              price="₹5,200"
            />
          </div>

      
          <div className="flight-column">
            <h3 className="flight-title">Return Flights</h3>

            <FlightCard
              logo={indigo}
              airline="IndiGo"
              flight="6E-890"
              time="18:00 - 19:30"
              duration="1h 30m"
              price="₹4,800"
            />

            <FlightCard
              logo={vistara}
              airline="Vistara"
              flight="UK-456"
              time="20:00 - 21:45"
              duration="1h 45m"
              price="₹5,600"
            />
          </div>
        </div>
      </div>
    );
  }
}

class FlightCard extends Component {
  render() {
    const { logo, airline, flight, time, duration, price } = this.props;

    return (
      <div className="flight-card">
       
        <div className="flight-left">
          <img src={logo} alt={airline} className="airline-logo" />
          <div>
            <div className="airline-name">{airline}</div>
            <div className="flight-no">{flight}</div>
          </div>
        </div>

      
        <div className="flight-middle">
          <div className="flight-time">{time}</div>
          <div className="flight-duration">{duration}</div>

          <div className="flight-features">
            <span>👜 Hand Baggage</span>
            <span>🧳 Check-in Baggage</span>
            <span className="green">Refundable</span>
            <span className="link">Fare Rules</span>
          </div>
        </div>

       
        <div className="flight-right">
          <div className="flight-price">{price}</div>
        </div>
      </div>
    );
  }
}

export default FlightList;
